/**
 * Horizontal Tabs Pattern
 * Switch active tab and show corresponding content panel on click.
 */
$(document).ready(function () {
  $(document).on('click', '.pattern-horizontal-tabs .ht-tab', function () {
    var $tab = $(this);
    var index = $tab.data('tab');
    var $pattern = $tab.closest('.pattern-horizontal-tabs');

    $pattern.find('.ht-tab').removeClass('active');
    $pattern.find('.ht-panel').removeClass('active');

    $tab.addClass('active');
    $pattern.find('.ht-panel[data-panel="' + index + '"]').addClass('active');
  });
});
